import { api } from '@/shared/api/client'

export interface TokenExchangeRequest {
  code: string
  code_verifier: string
  redirect_uri: string
}

export interface TokenExchangeResponse {
  accessToken?: string
  refreshToken?: string
  access_token?: string
  refresh_token?: string
}

export const ssoApi = {
  callback: async (payload: TokenExchangeRequest) => {
    const response = await api.post<TokenExchangeResponse>(
      '/auth/callback',
      payload,
      {
        _skipGlobalErrorHandler: true,
      } as any,
    )
    return response.data
  },
}
